(() => {
  window.addEventListener('DOMContentLoaded', () => {
    const audioPlayerContainer = document.querySelector('[data-component="oAudioPlayer"]');
    if (!audioPlayerContainer) { return; }

    const playIconContainer = audioPlayerContainer.querySelector('.oAudio__PlayIcon');
    const seekSlider = audioPlayerContainer.querySelector('.oAudio__SeekSlider');
    const volumeSlider = audioPlayerContainer.querySelector('.oAudio__Volume__Slider');
    const muteIconContainer = audioPlayerContainer.querySelector('.oAudio__MuteIcon');
    /* Implementation of the functionality of the audio player */
    const audio = audioPlayerContainer.querySelector('audio');
    const durationContainer = audioPlayerContainer.querySelector('.oAudio__Duration');
    const currentTimeContainer = audioPlayerContainer.querySelector('.oAudio__Time');
    const outputContainer = audioPlayerContainer.querySelector('.oAudio__Volume');
    let playState = 'play',
      muteState = 'unmute',
      raf = null;

    playIconContainer.addEventListener('click', () => {
        if(playState === 'play') {
            audio.play();
            requestAnimationFrame(whilePlaying);
            playState = 'pause';
            playIconContainer.classList.replace('play', 'pause');
        } else {
            audio.pause();
            cancelAnimationFrame(raf);
            playState = 'play';
            playIconContainer.classList.replace('pause', 'play');
        }
    });

    muteIconContainer.addEventListener('click', () => {
      if (muteState === 'unmute') {
        muteIconContainer.classList.replace('unmuted', 'muted');
        audio.muted = true;
        muteState = 'mute';
      } else {
        muteIconContainer.classList.replace('muted', 'unmuted');
        audio.muted = false;
        muteState = 'unmute';
      }
    });

    const showRangeProgress = (rangeInput) => {
      if (rangeInput === seekSlider) {
        audioPlayerContainer.style.setProperty('--seek-before-width', rangeInput.value / rangeInput.max * 100 + '%');
      } else {
        audioPlayerContainer.style.setProperty('--volume-before-width', rangeInput.value / rangeInput.max * 100 + '%');
      }
    }

    seekSlider.addEventListener('input', (e) => {
        showRangeProgress(e.target);
    });
    volumeSlider.addEventListener('input', (e) => {
        showRangeProgress(e.target);
    });

    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    }

    const displayDuration = () => {
        durationContainer.textContent = calculateTime(audio.duration);
    }

    const setSliderMax = () => {
        seekSlider.max = Math.floor(audio.duration);
    }

    const displayBufferedAmount = () => {
      if (audio.buffered.length) {
        const bufferedAmount = Math.floor(audio.buffered.end(audio.buffered.length - 1));
        audioPlayerContainer.style.setProperty('--buffered-width', `${(bufferedAmount / seekSlider.max).toFixed(3) * 100}%`);
      }
    }

    const whilePlaying = () => {
        seekSlider.value = Math.floor(audio.currentTime);
        currentTimeContainer.textContent = calculateTime(seekSlider.value);
        audioPlayerContainer.style.setProperty('--seek-before-width', `${seekSlider.value / seekSlider.max * 100}%`);
        raf = requestAnimationFrame(whilePlaying);
    }

    if (audio.readyState > 0) {
        displayDuration();
        setSliderMax();
        displayBufferedAmount();
    } else {
        audio.addEventListener('loadedmetadata', () => {
            displayDuration();
            setSliderMax();
            displayBufferedAmount();
        });
    }

    audio.addEventListener('progress', displayBufferedAmount);

    seekSlider.addEventListener('input', () => {
        currentTimeContainer.textContent = calculateTime(seekSlider.value);
        if(!audio.paused) {
            cancelAnimationFrame(raf);
        }
    });

    seekSlider.addEventListener('change', () => {
        audio.currentTime = seekSlider.value;
        if(!audio.paused) {
            requestAnimationFrame(whilePlaying);
        }
    });

    volumeSlider.addEventListener('input', (e) => {
        const value = e.target.value;

        outputContainer.textContent = value;
        audio.volume = value / 100;
    });


    /* Implementation of the Media Session API */
    if('mediaSession' in navigator) {
      const { title, artist, album, artwork } = audioPlayerContainer.dataset;
        navigator.mediaSession.metadata = new MediaMetadata({
            title: title || '',
            artist: artist || '',
            album: album || '',
            artwork: JSON.parse(artwork) || ''
        });

        navigator.mediaSession.setActionHandler('play', () => {
            if(playState === 'play') {
                audio.play();
                requestAnimationFrame(whilePlaying);
                playState = 'pause';
            } else {
                audio.pause();
                cancelAnimationFrame(raf);
                playState = 'play';
            }
        });
        navigator.mediaSession.setActionHandler('pause', () => {
            if(playState === 'play') {
                audio.play();
                requestAnimationFrame(whilePlaying);
                playState = 'pause';
            } else {
                audio.pause();
                cancelAnimationFrame(raf);
                playState = 'play';
            }
        });
        navigator.mediaSession.setActionHandler('seekbackward', (details) => {
            audio.currentTime = audio.currentTime - (details.seekOffset || 10);
        });
        navigator.mediaSession.setActionHandler('seekforward', (details) => {
            audio.currentTime = audio.currentTime + (details.seekOffset || 10);
        });
        navigator.mediaSession.setActionHandler('seekto', (details) => {
            if (details.fastSeek && 'fastSeek' in audio) {
              audio.fastSeek(details.seekTime);
              return;
            }
            audio.currentTime = details.seekTime;
        });
        navigator.mediaSession.setActionHandler('stop', () => {
            audio.currentTime = 0;
            seekSlider.value = 0;
            audioPlayerContainer.style.setProperty('--seek-before-width', '0%');
            currentTimeContainer.textContent = '0:00';
            if(playState === 'pause') {
                cancelAnimationFrame(raf);
                playState = 'play';
            }
        });
    }
  });

})();
